exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-b279b71a] {\n  padding: 14px 20px;\n  border: 1px dashed #ddd;\n  border-radius: 10px;\n  background-color: #f5fbff;\n  margin-bottom: 20px;\n}\n.width-50[data-v-b279b71a] {\n  width: 50px;\n}\n", ""]);

// exports
